module.exports = ".col-lg-10 {\r\n\tpadding-right: 0px;\r\n}\r\n\r\n.col-lg-2 {\r\n\tpadding-left: 0px;\r\n}\r\n\r\n.aside-pied {\r\n\theight: 50px ;\r\n\tborder-left: solid black;\r\n\tbackground-color: var(--api-jaune);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main